import React, { Component } from 'react';

import {FormattedHTMLMessage} from 'react-intl';

import BasicTemplate from './BasicTemplate.js'
import { WAButton } from '../components/Button.js';

class Greetings extends Component {

  render() {
      return (
          <BasicTemplate>
              <h3><b>Gracias por contactarte con nosotros!.</b></h3>
              <p>Cualquier duda o consulta que tengas podés comunicarte con nuestro Centro de Atención On Line.</p>
              <p>Saludos</p>
              <WAButton
                phone={this.context.intl.formatMessage({
                        id:"app.step_sms_whatsapp_number",
                        defaultMessage: "542612554220"})}
                text={this.context.intl.formatMessage({
                        id:"app.step_sms_whatsapp_text",
                        defaultMessage: "Tengo+una+consulta"})}
                value={this.context.intl.formatMessage({
                          id:"app.step_sms_whatsapp_label",
                          defaultMessage: "261-2554-220"})}
                gaEvent="true"
                gaCategory="CallToAction"
                gaAction="WhatsApp Tapping"
              />
          </BasicTemplate>
          );
  };
}

Greetings.contextTypes = {
  intl: React.PropTypes.object.isRequired
}

export default Greetings;


/** WEBPACK FOOTER **
 ** ./src/components/Greetings.js
 **/